// Module
var code = "<ui-view></ui-view> ";
// Exports
module.exports = code;